import { auth, db, requestFcmToken } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

const KEY = 'reminders_enabled';

/**
 * Captures the user's intent + FCM token for daily practice reminders.
 * NOTE: there is no scheduled Cloud Function in this project to actually
 * dispatch "come back and practice" pushes to inactive users — that needs a
 * server-side scheduled job reading `remindersEnabled`/`fcmToken` off each
 * user doc. This service does the client + data half of the feature; the
 * dispatch half is a deploy-time addition, not something achievable from
 * client code alone.
 */
export const ReminderService = {
  isEnabled() {
    return localStorage.getItem(KEY) === '1';
  },

  async enable() {
    const uid = auth?.currentUser?.uid;
    if (!uid || !db) return { ok: false, reason: 'signed_out' };
    const token = await requestFcmToken();
    if (!token) return { ok: false, reason: 'permission_denied' };
    try {
      await setDoc(doc(db, 'users', uid), {
        remindersEnabled: true,
        fcmToken: token,
      }, { merge: true });
      localStorage.setItem(KEY, '1');
      return { ok: true };
    } catch {
      return { ok: false, reason: 'error' };
    }
  },

  async disable() {
    localStorage.setItem(KEY, '0');
    const uid = auth?.currentUser?.uid;
    if (!uid || !db) return;
    try {
      await setDoc(doc(db, 'users', uid), { remindersEnabled: false }, { merge: true });
    } catch { /* best-effort — local preference is already saved */ }
  },
};
